import { AccountInfo, IPublicClientApplication } from "@azure/msal-browser";
import { ProjectCheck } from "../types/ProjectCheck";
import { TimePeriod } from "../types/TimePeriod";
import { UpdateProjectCheckDTO } from "../types/UpdateProjectCheckDTO";
import { authenticatedBackendFetch } from "./ApiService";
import { GetProjecChecksDTO } from "../types/GetProjecChecksDTO";

export async function GetProjectChecksAsync(
  instance: IPublicClientApplication,
  account: AccountInfo,
  userId: number,
  timePeriod: TimePeriod,
) {
  const response = await authenticatedBackendFetch(
    `projects/${userId}?month=${timePeriod.Month}&year=${timePeriod.Year}`,
    instance,
    account,
  );

  if (!response.ok) {
    console.error(response);
    return;
  }

  const data: GetProjecChecksDTO = await response.json();

  return data;
}

export async function SaveProjectCheckChangesAsync(
  instance: IPublicClientApplication,
  account: AccountInfo,
  projectChecks: ProjectCheck[],
  isCompleting = false,
  selectedPeriod: TimePeriod,
) {
  let updateDTOs: UpdateProjectCheckDTO[] = [];

  projectChecks.forEach((check) => {
    updateDTOs.push({
      id: check.id,
      checkedByManager: check.checkedByManager,
      managerComment: check.managerComment,
      checkedBySupervisor: check.checkedBySupervisor,
      supervisorComment: check.supervisorComment,
    });
  });

  const response = await authenticatedBackendFetch(`projects/save`, instance, account, {
    method: "POST",
    body: JSON.stringify({
      isCompleting: isCompleting,
      month: selectedPeriod.Month,
      year: selectedPeriod.Year,
      checks: updateDTOs,
    }),
  });

  if (!response.ok) {
    console.error(response);
    throw new Error("BadRequest");
  }
}

export async function RequestProjectRefreshAsync(
  instance: IPublicClientApplication,
  account: AccountInfo,
  crmProjectId: string,
) {
  const response = await authenticatedBackendFetch(
    `projects/refresh/${crmProjectId}`,
    instance,
    account,
    {
      method: "POST",
    },
  );

  if (!response.ok) {
    console.error(response);
    throw new Error();
  }
}
